import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

// ✅ Get all Lectures (by Module ID)
export const getLectures = createAsyncThunk(
  "admin/allLectures",
  async (
    { moduleId, workshopId, page, limit, searchData, type },
    { rejectWithValue }
  ) => {
    try {
      let url = `/lecture/all?page=${page}&limit=${limit}`;
      if (moduleId) {
        url += `&moduleFilter=${moduleId}`;
      }

      if (workshopId) {
        url += `&workshopFilter=${workshopId}`;
      }

      if (searchData) {
        url += `&search=${searchData}`;
      }
      if (type) {
        url += `&typeFilter=${type}`;
      }

      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Add Lecture
export const addLecture = createAsyncThunk(
  "admin/addLecture",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/lecture/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Edit Lecture
export const editLecture = createAsyncThunk(
  "admin/editLecture",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/lecture/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Get Single Lecture
export const getSingleLecture = createAsyncThunk(
  "admin/singleLecture",
  async (lectureId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/lecture/${lectureId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Delete Lecture
export const deleteLecture = createAsyncThunk(
  "admin/deleteLecture",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/lecture/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

// ✅ Initial State
const initialState = {
  lectureData: [], // all lectures list
  singleLectureData: {}, // for edit form
};

// ✅ Slice
const lectureSlice = createSlice({
  name: "lectureSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLectures.fulfilled, (state, action) => {
      state.lectureData = action.payload.data;
    });
    builder.addCase(getSingleLecture.fulfilled, (state, action) => {
      state.singleLectureData = action.payload.data;
    });
  },
});

export default lectureSlice.reducer;
